




















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ManualForm from "./ManualForm.vue";
import { ManualModel } from "../models";
import { postManual, postThumbnail, postPdf, putManual } from "../api";
import { namespace } from "vuex-class";
import { SnackbarInterface } from "shared/store/snackbar/state";

const snackStore = namespace("snackbar");

@Component({
  components: { ManualForm },
})
export default class ManualDialog extends Vue {
  @Prop({ required: true, type: Boolean }) public value!: boolean;
  @Prop({ required: true, type: Object }) public manual!: ManualModel;
  @Prop({ default: false, type: Boolean || String }) public createNew!:
    | boolean
    | string;
  @snackStore.Mutation setSnackbar!: (payload: SnackbarInterface) => void;

  thumbnail: File | null = null;
  pdf: File | null = null;
  reset = false;
  editableManual = new ManualModel();

  @Watch(`dialog`)
  watchDialog(val: boolean): void {
    if (!val) return;
    this.editableManual = this.manual.getCopy();
  }

  get dialog(): boolean {
    return this.value;
  }
  set dialog(v: boolean) {
    this.$emit("input", v);
  }

  get newManual(): boolean {
    return this.createNew !== false;
  }

  close(): void {
    this.dialog = false;
    this.editableManual = new ManualModel();
    this.thumbnail = null;
    this.pdf = null;
    this.reset = true;
  }

  async submit(): Promise<void> {
    let state = "data";
    try {
      let id: number;
      let extension: string | undefined;
      if (this.pdf !== null) {
        var re = /(?:\.([^.]+))?$/;
        const parts = re.exec(this.pdf.name);
        if (parts) extension = parts[1];
      }
      if (this.newManual) {
        id = await postManual(
          this.editableManual.getIPostManualRequest(extension)
        );
      } else {
        id = this.editableManual.id;
        await putManual(
          id,
          this.editableManual.getIPostManualRequest(extension)
        );
      }

      state = "bestanden";
      const promises: Promise<void>[] = [];

      if (this.thumbnail !== null) {
        promises.push(postThumbnail(id, this.thumbnail));
      }
      if (this.pdf !== null) {
        promises.push(postPdf(id, this.pdf));
      }

      await Promise.all(promises);

      this.close();
      this.$emit("listChanged");
    } catch (e) {
      this.setSnackbar({
        text: `Er is iets mis gegaan bij het opslaan van de ${state} (${e})`,
        color: "error",
      });
    }
  }
}
